define('controllers/finddestination',['require'],function(require) {
    return function () {
        var destinations = window.ServerData.feData.destinations;
        var txtSearch = $("#txtSearch");
        txtSearch.on("keyup", loadDestinationTable);

        loadDestinationTable();

        function loadDestinationTable() {
            var destinationHtmlBlocks = [],
                searchTerm = txtSearch.val().toLowerCase();

            for (var i = destinations.length - 1; i >= 0; i--) {
                var destination = destinations[i];
                if (searchTerm == "" || destination.RegionName.toLowerCase().indexOf(searchTerm) != -1) {
                    destinationHtmlBlocks.push("<tr data-DestinationRow='{0}'><td>{0}</td><td>{1}</td><td>{2}</td><td>{3}</td><td>{4}</td><td>{5}</td><td>{6}</td><td>{7}</td></tr>".format(destination.RegionID, destination.RegionName, destination.PrimaryAirportCode, destination.lat, destination.lon, destination.smallImage, destination.largeImage, destination.CreateDate));
                }
            }

            $("#destinations").html("<table class='table table-bordered'><tr><th>ID</th><th>Name</th><th>Primary Airport</th><th>Lat</th><th>Lon</th><th>Small Image</th><th>Large Image</th><th>Created</th></tr>" + destinationHtmlBlocks.join("") + "</table>");

            //set up handlers
            $("tr[data-DestinationRow]").off("click").on("click", function () {
                window.location = "editDestination.aspx?id=" + $(this).attr("data-DestinationRow");
            });
        }
    };
});

